import React from "react";
import "./SectionHeader.css";

export default ({ className = "", ...props }) => (
  <h5 className={`SectionHeader ${className}`} {...props}>
    {props.children}
  </h5>
);
